import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgAppleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 16.186C0 8.644 0 4.872 2.343 2.529S8.458.186 16 .186c7.543 0 11.314 0 13.657 2.343S32 8.644 32 16.186c0 7.543 0 11.314-2.343 13.657S23.543 32.186 16 32.186c-7.542 0-11.314 0-13.657-2.343S0 23.729 0 16.186Z"
      fill="#17181A"
    />
    <g clipPath="url(#AppleIcon_svg__a)" fill="#fff">
      <path d="M19.977 5.196c-.043-.047-1.574.019-2.907 1.465-1.332 1.445-1.127 3.103-1.097 3.145.03.043 1.9.109 3.094-1.572 1.193-1.682.952-2.99.91-3.038Zm4.142 14.666c-.06-.12-2.906-1.542-2.641-4.277.265-2.737 2.093-3.487 2.122-3.568.029-.081-.746-.987-1.567-1.446a4.616 4.616 0 0 0-1.954-.543c-.135-.003-.604-.118-1.567.146-.636.173-2.067.736-2.46.758-.396.023-1.57-.652-2.834-.831-.809-.156-1.666.164-2.28.41-.613.245-1.778.943-2.593 2.796-.815 1.853-.388 4.788-.083 5.7.305.912.78 2.405 1.59 3.495.72 1.23 1.676 2.084 2.075 2.374.398.29 1.523.482 2.303.084.628-.385 1.76-.607 2.208-.59.446.016 1.326.192 2.227.674.714.246 1.389.143 2.065-.132.677-.276 1.655-1.323 2.798-3.447.434-.988.631-1.521.591-1.603Z" />
      <path d="M19.977 5.196c-.043-.047-1.574.019-2.907 1.465-1.332 1.445-1.127 3.103-1.097 3.145.03.043 1.9.109 3.094-1.572 1.193-1.682.952-2.99.91-3.038Zm4.142 14.666c-.06-.12-2.906-1.542-2.641-4.277.265-2.737 2.093-3.487 2.122-3.568.029-.081-.746-.987-1.567-1.446a4.616 4.616 0 0 0-1.954-.543c-.135-.003-.604-.118-1.567.146-.636.173-2.067.736-2.46.758-.396.023-1.57-.652-2.834-.831-.809-.156-1.666.164-2.28.41-.613.245-1.778.943-2.593 2.796-.815 1.853-.388 4.788-.083 5.7.305.912.78 2.405 1.59 3.495.72 1.23 1.676 2.084 2.075 2.374.398.29 1.523.482 2.303.084.628-.385 1.76-.607 2.208-.59.446.016 1.326.192 2.227.674.714.246 1.389.143 2.065-.132.677-.276 1.655-1.323 2.798-3.447.434-.988.631-1.521.591-1.603Z" />
    </g>
    <defs>
      <clipPath id="AppleIcon_svg__a">
        <path fill="#fff" transform="translate(6 5.186)" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
);
const Memo = memo(SvgAppleIcon);
export default Memo;
